import React from 'react';
import { FormControlLabel, Switch } from '@mui/material';
import {
  useTouchModeEnabled,
  useCalibrationUIStore
} from '@stores/calibrationUIStore';

type TouchModeToggleProps = {
  label?: string;
  sx?: any;
  disabled?: boolean;
};

export const TouchModeToggle: React.FC<TouchModeToggleProps> = ({
  label = 'Touch Mode',
  sx,
  disabled = false
}) => {
  const touchModeEnabled = useTouchModeEnabled();
  const setTouchModeEnabled = useCalibrationUIStore(
    state => state.setTouchModeEnabled
  );

  const handleTouchModeToggle = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setTouchModeEnabled(event.target.checked);
  };

  return (
    <FormControlLabel
      control={
        <Switch
          checked={touchModeEnabled}
          onChange={handleTouchModeToggle}
          size="small"
          disabled={disabled}
        />
      }
      label={label}
      sx={sx}
    />
  );
};
